import {
  TableBuildingGroupsListCell,
  TableDateCell,
  TableEmptyCell,
  TableTextCell,
  TableTitleCell,
  TableUserListCell,
  TextListCell,
  toTableBuildingGroupsListCell,
  toTableCellTextFromName,
} from '../../Table'
import { toUserMultiValue } from '../../User'

import { BuildingTableCellName } from './BuildingTableRow.constants'

export function renderCell({ item, name, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case BuildingTableCellName.Title:
      return (
        <TableTitleCell
          {...restProps}
          avatarProps={{ src: item.avatar }}
          labels={item.labels}
          value={value}
        />
      )

    case BuildingTableCellName.PropertyOwners:
    case BuildingTableCellName.ResponsibleUsers:
      return (
        <TableUserListCell
          {...restProps}
          value={value?.map(toUserMultiValue)}
        />
      )

    case BuildingTableCellName.BuildingGroups:
      return (
        <TableBuildingGroupsListCell
          {...restProps}
          value={value?.map(toTableBuildingGroupsListCell)}
        />
      )

    case BuildingTableCellName.RequestCategories:
      return (
        <TextListCell
          {...restProps}
          value={value?.map(toTableCellTextFromName)}
        />
      )

    case BuildingTableCellName.ContractEnd:
    case BuildingTableCellName.ContractStart:
    case BuildingTableCellName.Created:
    case BuildingTableCellName.Updated:
      return <TableDateCell {...restProps} value={value} />

    case BuildingTableCellName.InsuranceSupplier:
    case BuildingTableCellName.InsuranceType:
    case BuildingTableCellName.LivingType:
    case BuildingTableCellName.Salutation:
      return <TableTextCell {...restProps} value={value?.value} />

    case BuildingTableCellName.AddressInvoice:
    case BuildingTableCellName.AmountRestriction:
    case BuildingTableCellName.BankAccountOwner:
    case BuildingTableCellName.BankBIC:
    case BuildingTableCellName.BankIBAN:
    case BuildingTableCellName.BankName:
    case BuildingTableCellName.ConstructionYear:
    case BuildingTableCellName.DoorNumber:
    case BuildingTableCellName.ExternalId:
    case BuildingTableCellName.FlatCount:
    case BuildingTableCellName.FullAddress:
    case BuildingTableCellName.HouseKeeper:
    case BuildingTableCellName.InhabitantCount:
    case BuildingTableCellName.InsuranceContractNumber:
    case BuildingTableCellName.Location:
    case BuildingTableCellName.ORAGAccountant:
    case BuildingTableCellName.ORAGAssetManager:
    case BuildingTableCellName.ORAGBroker:
    case BuildingTableCellName.ORAGIdenticalAddress:
    case BuildingTableCellName.ORAGNumberOwner:
    case BuildingTableCellName.ORAGTaxConsultant:
    case BuildingTableCellName.ORAGWarranty:
    case BuildingTableCellName.ObjectNumber:
    case BuildingTableCellName.PostalCode:
    case BuildingTableCellName.Street:
      return <TableTextCell {...restProps} value={value} />

    default:
      return <TableEmptyCell {...restProps} />
  }
}
